import { useMemo } from 'react';
import { usePlugins } from "./usePlugins.js";
import { getPluginsElementMap } from "./PluginUtils.js";
/**
 * Get all ElementPlugin elements from the plugins context
 * @returns ElementPlugin mapping as a Map of plugin name to component type
 */
export function usePluginsElementMap() {
  // Get all plugins from the context
  var plugins = usePlugins();
  var elementPlugins = useMemo(() => getPluginsElementMap(plugins), [plugins]);
  return elementPlugins;
}
export default usePluginsElementMap;
//# sourceMappingURL=usePluginsElementMap.js.map